import React from 'react';

const Step1 = () => {
  return (
    <div style={{ minHeight: "70vh" }}>
      <h2>¡Hola!</h2>
      <p style={{ textAlign: "left", padding: "10px"}}>Para tener una videoconsulta óptima con tu profesional de salud, sugerimos realizar el siguiente test desde el lugar dónde vayas a tener tu videoconsulta.</p>

      <p style={{ textAlign: "left", fontWeight: 800, padding: "10px" }}>Verificaremos:</p>
      <ol>
        <li style={{ textAlign: "left" }}>Micrófono.</li>
        <li style={{ textAlign: "left" }}>Sonido.</li>
        <li style={{ textAlign: "left" }}>Cámara.</li>
        <li style={{ textAlign: "left" }}>Red.</li>
      </ol>

      <p style={{ textAlign: "left", fontWeight: 300, fontSize: "12px", padding: "10px" }}>
        Todos los datos capturados en este test no se compartirán con nadie a menos que hagas clic en el botón "Compartir" al finalizar.
        </p>
    </div>
  );
};

export default Step1;